import { CloudAuthSignedInState, HubToken, useCloudAuth } from '@itential/cloud-auth-client';

export function useHasJobViewerEntitlement(): boolean {
    const { state } = useCloudAuth();
    const signedIn = state as CloudAuthSignedInState;
    const hubToken = signedIn?.decodedHubToken as HubToken;
    const entitlements = hubToken?.tenant?.products;
    return entitlements ? 'job-viewer' in entitlements : false;
}
